/* eslint-disable react/forbid-prop-types */
import { useReducer, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { nanoid } from "nanoid";
import { dialogReducer, dialogInitState } from "reducers/dialog";
import Dialog from "components/Dialog/Dialog";
import deleteAttachmentEsri from "utils/deleteAttachmentEsri";
import { useEsriUrls } from "context/esriUrlsContext";

function AttachmentsTable(props) {
  const {
    files,
    className,
    downloadable,
    deletable,
    setFiles,
    attachmentsHasChanged,
    featureName,
    objectId,
    isReducer,
    dispatcher,
  } = props;
  const [esriUrls] = useEsriUrls();

  const [fileToDelete, setFileToDelete] = useState(null);
  const [featureUrl, setFeatureUrl] = useState("");
  const [dialogState, dispatchDialog] = useReducer(
    dialogReducer,
    dialogInitState
  );
  const toggleDialog = (file, idx) => {
    if (file) setFileToDelete({ file, idx });
    dispatchDialog({ type: "TOGGLE" });
  };

  const deleteFile = () => {
    const { file, idx } = fileToDelete;
    if (file.id && objectId) {
      deleteAttachmentEsri({
        url: featureUrl,
        objectId,
        attachmentIds: [file.id],
      });
    }
    if (!isReducer)
      setFiles((prevFiles) => {
        const tempFiles = [...prevFiles];
        tempFiles.splice(idx, 1);
        return tempFiles;
      });
    else {
      const tempFiles = [...files];
      tempFiles.splice(idx, 1);
      dispatcher({ type: "fileChange", payload: tempFiles });
    }

    toggleDialog();
    attachmentsHasChanged.current = true;
  };
  useEffect(() => {
    if (esriUrls[featureName]) {
      // const token = localStorage.getItem("token");
      // ?${
      //   token ? `&token=${token}` : ""
      // }
      const tempUrl = `${process.env.REACT_APP_SERVICE_ENDPOINT}/${process.env.REACT_APP_FZ_Tables_N}/FeatureServer/${esriUrls[featureName]}`;
      setFeatureUrl(tempUrl);
    }
  }, [esriUrls, featureName]);

  return (
    <>
      <div className={`attachments_table ${className}`}>
        <h6>المرفقات</h6>
        <table>
          <thead>
            <tr>
              <th>اسم الملف</th>
              {downloadable && <th>تحميل الملف</th>}
              {deletable && <th>حذف الملف</th>}
            </tr>
          </thead>
          <tbody>
            {files && !!files?.length
              ? files.map((file, idx) => (
                  <tr key={nanoid()}>
                    <td>{file.name}</td>
                    {downloadable && (
                      <td>
                        <a
                          download
                          href={file.url}
                          target="_blank"
                          rel="noreferrer"
                        >
                          تحميل
                        </a>
                      </td>
                    )}
                    {deletable && (
                      <td>
                        <button
                          type="button"
                          onClick={toggleDialog.bind(this, file, idx)}
                        >
                          <i className="bi bi-trash-fill" />
                        </button>
                      </td>
                    )}
                  </tr>
                ))
              : null}
            {files.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center p-3">
                  لا توجد مرفقات
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <Dialog
        state={dialogState}
        dispatch={dispatchDialog}
        footer={false}
        title="تأكيد حذف الملف"
        closeButton
        centered
        className="z-1057"
        backdropClassName="z-1056"
      >
        <button
          type="button"
          className="btn btn--primary"
          onClick={deleteFile}
          style={{ marginInlineEnd: "1rem" }}
        >
          نعم
        </button>
        <button type="button" className="btn btn--red" onClick={toggleDialog}>
          لا
        </button>
      </Dialog>
    </>
  );
}

AttachmentsTable.defaultProps = {
  className: "",
  downloadable: false,
  deletable: false,
  files: [],
  setFiles: () => {},
  attachmentsHasChanged: { current: false },
  featureName: "",
  objectId: 0,
  isReducer: false,
  dispatcher: () => {},
};

AttachmentsTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  files: PropTypes.array,
  setFiles: PropTypes.func,
  attachmentsHasChanged: PropTypes.object,
  className: PropTypes.string,
  downloadable: PropTypes.bool,
  deletable: PropTypes.bool,
  featureName: PropTypes.string,
  objectId: PropTypes.number,
  isReducer: PropTypes.bool,
  dispatcher: PropTypes.func,
};

export default AttachmentsTable;
